// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EsBka","icon":"styles_icon__IYCVW"};